<div class="tab-pane show active" id="pills-amcdetail"
role="tabpanel" aria-labelledby="pills-amcdetail-tab">
<h1 class="page-sub-title cv-text-dark mb-4 mt-4 d-flex align-items-center"><a (click)="mobileBack()"
    class=""><img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2"
      loading="lazy" /></a>VAS Digital Dashboard</h1>
<div class="row p-3 pb-0">
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 co-xl-6 mb-4">
    <div class="upload-document">
      <label class="form-label mend">Phone No.</label>
      <input type="text" class="form-control h-48" placeholder="+91 99999 99999" minlength="10"
         value={{this.userData?.mobile_number}} disabled="true"/>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-6 col-lg-6 co-xl-6 mb-4">
    <div class=" mb-3">
      <label class="form-label" style="color: #27292F;font-weight: 700; font-size: 16px;">Pan
       Card</label>
       <input type="text" class="form-control h-48" placeholder="EX:ABCDE9999Z" maxlength="10"
       minlength="10" oninput="this.value = this.value.toUpperCase()"
        (keydown)="notAllowSpace($event)"  [(ngModel)]="pancard" />
    </div>
  </div>

</div>
<div class="d-flex col-12 col-lg-6 p-3 justify-content-between">
  <div>
  <input class="form-check-input mb-1" style="border: 1px solid black;" type="checkbox" value="" #myCheckbox (change)="onCheckboxChange(myCheckbox.checked)" id="flexCheckDefault">
  <label class="form-check-label ms-3" for="flexCheckDefault">
    <div>
      Click To Continue That You Agree To
    </div>
  </label> <a class="text-primary " style="cursor: pointer;" (click)="gototerms()">  Terms & Conditions</a>
 </div>

 </div>
<div class="row p-3">
  <label style="color: red;">
    Kindly use Mobile number and PAN card provided at the time of Vehicle purchase.
  </label>
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 offset-md-6 text-end mb-3">
    <button type="button" [ngClass]="{'disabled': !checkBoxcheked}"
      class="btn w-50 btn-primary btn-lg btn-grad-primary btn-compare"
      (click)="verifyVas()" data-toggle="tooltip" data-placement="top"
      title="Click here to view">View </button>
  </div>
</div>


</div>
